import React from "react";
import { Link } from "react-router-dom";
import { Card } from "../components/ui/card";
import { Truck, MapPin, Upload, ChevronRight, Clock, AlertTriangle, ImageIcon, Map } from "lucide-react";

const items = [
  { to: "/settings/mezzi", label: "Mezzi", desc: "Gestione flotta furgoni", icon: Truck, testid: "settings-mezzi" },
  { to: "/settings/zone", label: "Zone", desc: "Aree operative, giorno di servizio, ordinamento", icon: Map, testid: "settings-zone" },
  { to: "/settings/geocoding", label: "Geocoding", desc: "Trova coordinate con Nominatim", icon: MapPin, testid: "settings-geocoding" },
  { to: "/settings/fasce", label: "Fasce orarie", desc: "Confini per raggruppamento giro", icon: Clock, testid: "settings-fasce" },
  { to: "/settings/scadenze", label: "Soglie scadenze", desc: "Allerta gialla e rossa configurabili", icon: AlertTriangle, testid: "settings-scadenze" },
  { to: "/settings/logo", label: "Logo aziendale", desc: "Visualizzato nel foglio di giro stampabile", icon: ImageIcon, testid: "settings-logo" },
  { to: "/settings/import", label: "Importazione dati", desc: "CSV o Excel con produttori", icon: Upload, testid: "settings-import" },
];

export default function Settings() {
  return (
    <div className="space-y-4" data-testid="settings-page">
      <div>
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900">Impostazioni</h1>
        <p className="text-slate-500 text-sm mt-1">Configurazione e strumenti</p>
      </div>
      <ul className="space-y-2">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <li key={it.to}>
              <Link to={it.to} data-testid={it.testid}>
                <Card className="p-4 bg-white border border-slate-200 shadow-sm card-hover flex items-center gap-3">
                  <div className="h-11 w-11 rounded-lg bg-[#1B5E20]/10 text-[#1B5E20] flex items-center justify-center">
                    <Icon size={22} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>{it.label}</div>
                    <div className="text-xs text-slate-500">{it.desc}</div>
                  </div>
                  <ChevronRight size={20} className="text-slate-400" />
                </Card>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
